type MatchedMedia = 'desktop' | 'mobile';

const getMatchedMedia = (matchedMedia: string): MatchedMedia => {
  switch (matchedMedia) {
    case 'nav':
    case 'desktopwide':
    case 'desktop':
    case 'tablet':
      return 'desktop';
    case 'tabletwide':
    case 'handheld':
    default:
      return 'mobile';
  }
};

export default getMatchedMedia;
